module.exports = __webpack_public_path__ + "img/f78f79dbd3731c909cd14eb26d9000bf.png";